import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import cx from 'classnames';
import { Icon } from 'components/Icon';
import { Pill } from 'components/Misc';
import { Inline, Paragraph, LineBreak } from 'components/Typography';
import { omitProps } from 'utils/react';
import { ToggleableContext } from 'utilsTS/hooks';
import { NewButton as Button } from 'components/Button';
import { Flex } from 'components/Layout/Flex';
import styles from './DropdownFooter.module.scss';

export default class DropdownFooter extends Component {
    static displayName = 'DropdownFooter';

    static ICON = Icon.ICON;

    static propTypes = {
        icon: PropTypes.oneOf(Object.values(DropdownFooter.ICON)).isRequired,
        label: PropTypes.string.isRequired,
        pill: PropTypes.number,
        href: PropTypes.string,
        className: PropTypes.string,
        onClick: PropTypes.func,
        closeOnClick: PropTypes.bool,
        children: PropTypes.node,
    };

    static contextType = ToggleableContext;

    static defaultProps = {
        pill: null,
        href: '',
        className: null,
        onClick: noop,
        closeOnClick: true,
        children: null,
    };

    handleClick = (event) => {
        const { onClick, closeOnClick } = this.props;
        onClick(event);
        if (closeOnClick) {
            const { close } = this.context;
            close();
        }
    };

    render() {
        const { children, className, href, icon, label, pill, ...rest } = this.props;
        return (
            <Flex
                {...omitProps(rest, DropdownFooter)}
                className={cx(styles.dropdownFooter, className)}
                align={Flex.ALIGN.CENTER}
                gap={Flex.GAP.LG}
            >
                <Inline className={styles.icon}>
                    <Icon icon={icon} color={Icon.COLOR.BLUE_300} size={Icon.SIZE.SIZE_24} />
                    {pill && (
                        <Pill className={styles.pill} value={pill} variant={Pill.VARIANT.UNREAD} />
                    )}
                </Inline>
                <Paragraph small faded className={styles.description}>
                    <Button
                        href={href}
                        variant={Button.VARIANT.SECONDARY}
                        size={children ? Button.SIZE.SMALL : Button.SIZE.MEDIUM}
                        className={styles.button}
                        labelClassName={styles.label}
                        onClick={this.handleClick}
                    >
                        {label}
                    </Button>
                    {children && <LineBreak />}
                    {children}
                </Paragraph>
            </Flex>
        );
    }
}
